<template>
  <PageLayout title="Organisation" class="!p-0">
    <div class="h-full flex flex-col grow overflow-hidden" v-if="type !== 'xs'">
      <div class="flex grow bg-[#F2F4F7]">
        <div class="flex flex-col grow overflow-x-scroll">
          <slot />
        </div>
      </div>
    </div>
    <div v-else>
      <slot />
    </div>
  </PageLayout>
</template>

<script setup>
import PageLayout from "@/Layouts/PageLayout.vue";
import { useBreakpoints } from "@/Tailwind/Mixins/useBreakpoints";

const { type } = useBreakpoints();
</script>
